import { render, staticRenderFns } from "./Siderail.vue?vue&type=template&id=4813fb41&"
import script from "./Siderail.vue?vue&type=script&lang=js&"
export * from "./Siderail.vue?vue&type=script&lang=js&"
import style0 from "./Siderail.vue?vue&type=style&index=0&id=4813fb41&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports